import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {WfInquiriesContainerModel} from "../../../../../../models/aggregates/wf/inquiries";
import { FilesDetailsRequest } from '../../../../../../models/file-image';

@Injectable({providedIn: 'root'})
export class WfInquiriesService extends BaseApiTemplateService<WfInquiriesContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'inquiries';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + 'inquiries';
    this.httpClient = http;
  }

  addAttachmentsAndDetailsInquiries(guid: string, files: File[], visa: ApiVisa,
    filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('file', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'multipart/form-data' }),
        'files-data.json')
    }

    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl + '/wf/file/' + guid + '/upload',
      formData,
      this.getHttpHeader(visa)
    );
  }
}
